import React from 'react';
import { CircularProgress, Grid } from '@mui/material';
import { Colors } from '../utils/Colors';

export function Loading() {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ height: '50vh' }}
    >
      <CircularProgress size={100} style={{ color: `${Colors.ocdGreen}` }} />
    </Grid>
  );
}
